import styled from 'styled-components';
import { Typography } from '@mui/material';
import colors from 'styles/colors';
import fonts from 'styles/fonts';

export const CopyButton = styled.button`
  font-family: ${fonts.primary.regular};
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  /* identical to box height, or 125% */

  text-align: center;
  color: ${({
    palette,
    hoverColors: {
      onHover: { color, tone },
    },
  }) => palette[`${color}`][`${tone}`]};
  display: list-item;
  white-space: normal;
  word-wrap: break-word;
  width: 178px;
  list-style-type: none;
`;
export const CopiedLabel = styled(Typography)`
  /* identical to box height, or 125% */

  text-align: center;

  color: ${colors.functional.darkGrey};
  width: 178px;
`;
